import axios from "axios";
import { toast } from "react-toastify";
import { getErrorMessage } from "@ten24/slatwall-storefront-react-private/global";

import { Payload } from "../interface";
import { useCallback } from "react";

const stringObject = (o: any) => {
  Object.keys(o).forEach((k) => {
    o[k] = "" + o[k];
  });
  return o;
};

const sdkURL = process.env.REACT_APP_API_URL;

const useGeneralFormService = () => {
  const formResponseSubmitAction = useCallback(async (newPayload: Payload, formReference: string) => {
    console.log("start addFormResponse ");
    const formSubmitResponse = await axios({
      method: "POST",
      withCredentials: true,
      url: `${sdkURL}api/scope/addFormResponse`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { ...stringObject({ ...newPayload }), formResponse: { formID: formReference } },
    }).then((resp) => {
      console.log("end addFormResponse ");
      if (resp?.data?.failureActions?.length) toast.error(getErrorMessage(resp?.data?.errors));
      return { ...resp?.data?.data, status: resp?.status };
    });
    for (const fileKey of Object.keys(formSubmitResponse?.uploadDetails ? formSubmitResponse.uploadDetails : {})) {
      let xmlHeaderInputs = formSubmitResponse.uploadDetails[fileKey];
      let fileHeader = { file: newPayload[`${fileKey}-file`] };
      console.log(`start file post for ${fileKey} `);
      await axios({
        method: "POST",
        url: xmlHeaderInputs?.url,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: { ...xmlHeaderInputs?.inputs, ...fileHeader },
      })
        .then((res) => {
          console.log(`end file post for ${fileKey} `, res);
        })
        .catch((err) => {
          // Handle error
          console.log("error", err);
        });
    }

    console.log("finish addFormResponse", formSubmitResponse?.status);
  }, []);

  return { formResponseSubmitAction };
};

export default useGeneralFormService;
